module.exports = __webpack_public_path__ + "img/图片2.36115f57.png";